import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes

export default function InactivityGuard({ children }) {
  const { authenticated, onLogout } = useAuth();
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    // Ne démarrer le timer que si l'utilisateur est authentifié
    if (!authenticated) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    const handleInactivity = async () => {
      console.log("Inactivité détectée (5 minutes). Déconnexion...");
      await onLogout(); // Logout API pour plus de sécurité
      navigate("/", { replace: true });
    };

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(handleInactivity, INACTIVITY_TIMEOUT);
    };

    // Events to track activity
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    const onActivity = () => {
      resetTimer();
    };

    events.forEach((event) => window.addEventListener(event, onActivity));

    // Démarrer le timer initial
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, onActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [authenticated, onLogout, navigate]);

  return <>{children}</>;
}
